import { FLUID_NOTIFICATION_PRESENTATION } from '@/features/fluid/constants/notification';
import { NOTIFICATION_ACTION, NOTIFICATION_CODE } from './notification';

export const NOTIFICATION_PRESENTATION = Object.freeze({
  ...FLUID_NOTIFICATION_PRESENTATION,
  [NOTIFICATION_CODE.EMOTION_CHECKIN]: {
    icon: 'smile',
    tone: 'success',
    response: { outcomes: { [NOTIFICATION_ACTION.FULFILLED]: 'notifications.outcomes.moodSaved' } },
  },
  [NOTIFICATION_CODE.MEDICATION_REMINDER]: { icon: 'pill', tone: 'orange' },
});

export const NOTIFICATION_TONE_CLASS = Object.freeze({
  info: 'tw:text-primary-foreground tw:bg-primary',
  destructive: 'tw:text-(--destructive) tw:bg-(--destructive-soft)',
  success: 'tw:text-(--success) tw:bg-(--success-soft)',
  orange: 'tw:text-(--orange-strong) tw:bg-(--orange-soft)',
  violet: 'tw:text-(--violet) tw:bg-(--violet-soft)',
  warning: 'tw:text-(--warning) tw:bg-(--warning-soft)',
  teal: 'tw:text-primary-foreground tw:bg-primary',
});
